module.exports = __webpack_public_path__ + "media/images/common/icon/icon-user-b-ff9780e4a54cc47876406931fc5e00c4.svg";